import {
  axiosGet,
  axiosPatch,
  axiosPost,
  axiosDelete,
} from "../../../app/Helpers/AxiosHelper";

import {
  subscribeToProject,
  unsubscribeFromProject,
  disconnect as disconnectRealtime,
  isConnected as isRealtimeConnected,
} from "../../../app/services/TaskRealtimeService";

import {
  ALLTASK,
  ACCOUNTS_PROJECT,
  CREATE_PROJECT,
  CREATE_COLUMN,
  CREATE_TASK,
  CREATE_TAG,
  CREATE_LOG_TIMER,
  BASE_TASK,
  ARCHIVETASK,
  TASK_NOTES,
  CREATE_EMAIL_SNIPPET,
} from "../../../app/Config/ApiUrl";

import {
  QueryColumns,
  QueryLogTimer,
  QueryNotifications,
  QuerySnippet,
} from "../../../app/Components/Views/tasks/apps/tasks/queries";

import {
  CommandCreateStep,
  CommandCreateTask,
} from "../../../app/Components/Views/tasks/apps/tasks/commands";

import { Note } from "../../../app/Components/Views/tasks/apps/tasks/entities";

import { QueryProject } from "../../../app/Components/Views/tasks/apps/projects/queries";

import {
  Queue,
  Step,
} from "../../../app/Components/Views/tasks/apps/tasks/entities";

export default {
  state: {
    startReload: false,
    // Incremented whenever a live customer reply lands, so views showing the
    // "New replies" count know to refresh it.
    clientReplyPing: 0,
    // Bumped when a live comment turns a card unread that was not already so.
    // Lets the views move the "Unread" badge at the same instant the outline
    // appears, instead of waiting for the server to catch up.
    unreadDelta: 0,
    worker: null,
    user: null,
    project: {},
    realtimeSubscribed: false,
    projects: [],
    task_templates: [],
    clients: [],
    project_files: [],
    owner: {},
    kanban_view_data: [],
    projects_loading: true,
    kanban_view_data_loaded: false,
    timers: [],
    tags: [],
    trigger_update: 0,
    newtab: {},
    isWhole: false,
    notifications: null,
    unread_notifications: [],
    read_notifications: [],
    unread_currentPage: 1,
    read_currentPage: 1,
    unread_nextPage: "init",
    read_nextPage: "init",
    client: null,
    isClient: false,
    hasFilter: false,
    format: null,
    taskService: {},
    textEditorToolbar: {
      toolbar: [
        ["style", ["bold", "italic", "underline", "clear"]],
        ["font", ["strikethrough", "superscript", "subscript"]],
        ["fontsize", ["fontsize"]],
        ["color", ["color"]],
        ["table", ["table"]],
        ["para", ["ul", "ol", "paragraph"]],
        ["height", ["height"]],
        ["insert", ["link"]],
      ],
      disableResizeEditor: true,
    },
    users: {
      loaded: false,
      data: [],
      error: false,
    },
    project_users: [],
    count: 0,
    loggers: [],
    steps: [],
    requestSettings: null,
    generalSettings: null,
    visibleSteps: [],
    projectCanBeLoad: true,
    projectIsLoading: false,
    nextProjectPage: 1,
    itemsPerPage: null,
    sorted: null,
    filtersNotifications: [],
    commentSort: "newest",

    // Canned replies an agent can insert while commenting. Loaded once per
    // project, shared by every comment editor (task sidebar, reply box, request
    // sidebar) so opening a task does not refetch the same list each time.
    reply_snippets: {
      loaded: false,
      loading: false,
      projectId: null,
      data: [],
    },

    loadingNotification: true,
  },

  getters: {
    clientReplyPing: (state) => state.clientReplyPing,
    unreadDelta: (state) => state.unreadDelta,
    replySnippets: (state) => state.reply_snippets.data,
    replySnippetsLoaded: (state) => state.reply_snippets.loaded,
    startLoadnotification: (state) => state.loadingNotification,
    filtersNotifications: (state) => state.filtersNotifications,
    getLoggerFormat: (state) => state.format,
    getItemPerPage: (state) => state.itemsPerPage,
    projectIsLoading: (state) => state.projectIsLoading,
    projectCanBeLoad: (state) => state.projectCanBeLoad,
    nextProjectPage: (state) => state.nextProjectPage,
    task_templates: (state) => state.task_templates,
    worker: (state) => state.worker,
    isWhole: (state) => state.isWhole,
    textEditorToolbar: (state) =>
      JSON.parse(JSON.stringify(state.textEditorToolbar)),
    generalSettings: (state) =>
      JSON.parse(JSON.stringify(state.generalSettings)),
    clients: (state) => JSON.parse(JSON.stringify(state.clients)),
    steps: (state) => JSON.parse(JSON.stringify(state.steps)),
    projectClients: (state) => JSON.parse(JSON.stringify(state.clients)),
    taskService: (state) => JSON.parse(JSON.stringify(state.taskService)),
    client: (state) => JSON.parse(JSON.stringify(state.client)),
    project_files: (state) => JSON.parse(JSON.stringify(state.project_files)),
    isClient: (state) => state.isClient,
    hasFilter: (state) => state.hasFilter,
    visibleSteps: (state) => state.visibleSteps,
    requestSettings: (state) =>
      JSON.parse(JSON.stringify(state.requestSettings)),
    notifications:
      (state) =>
      (type, groupbydate = false) => {
        let outdata;

        let notifs = JSON.parse(JSON.stringify(state.notifications));
        switch (type) {
          case "unread":
            notifs = notifs.filter(({ has_read }) => has_read == false);
            if (groupbydate) {
              let temp = {};
              for (let index = 0; index < notifs.length; index++) {
                const notif = notifs[index];

                let el = temp[notif.created_at];
                if (temp[notif.created_at]) {
                  temp[notif.created_at].push(notif);
                } else {
                  temp[notif.created_at] = [notif];
                }
              }

              outdata = temp;
            } else outdata = JSON.parse(JSON.stringify(state.notifications));
            break;
          case "read":
            notifs = notifs.filter(({ has_read }) => has_read == true);
            if (groupbydate) {
              let temp = {};
              for (let index = 0; index < notifs.length; index++) {
                const notif = notifs[index];

                let el = temp[notif.created_at];
                if (temp[notif.created_at]) {
                  temp[notif.created_at].push(notif);
                } else {
                  temp[notif.created_at] = [notif];
                }
              }
              outdata = temp;
            } else outdata = JSON.parse(JSON.stringify(state.notifications));
            break;
          default:
            outdata = JSON.parse(JSON.stringify(state.notifications));
            break;
        }
        return outdata;
      },
    unread_nextPage: (state) => state.unread_nextPage,
    read_nextPage: (state) => state.read_nextPage,
    read_notifications: (state) => {
      let outdata = [];
      if (state.read_notifications) {
        let notifs = JSON.parse(JSON.stringify(state.read_notifications));
        let temp = {};
        for (let index = 0; index < notifs.length; index++) {
          const notif = notifs[index];

          let el = temp[notif.created_at];
          if (temp[notif.created_at]) {
            temp[notif.created_at].push(notif);
          } else {
            temp[notif.created_at] = [notif];
          }
        }
        outdata = temp;
      }

      return outdata;
    },
    unread_notifications: (state) => {
      let outdata = [];
      if (state.unread_notifications) {
        let notifs = JSON.parse(JSON.stringify(state.unread_notifications));
        let temp = {};
        for (let index = 0; index < notifs.length; index++) {
          const notif = notifs[index];

          let el = temp[notif.created_at];
          if (temp[notif.created_at]) {
            temp[notif.created_at].push(notif);
          } else {
            temp[notif.created_at] = [notif];
          }
        }
        outdata = temp;
      }

      return outdata;
    },
    tags: (state) => JSON.parse(JSON.stringify(state.tags)),
    swatches: (state) => JSON.parse(JSON.stringify(state.swatches)),
    projects_loading: (state) => state.projects_loading,
    project: (state) => {
      return {
        ...state.project,
        notClient: state.project?.assignees?.filter((user) => !user.is_client),
      };
    },
    users: (state) => {
      return {
        ...state.users,
      };
    },
    canDoActions:
      (state) =>
      ({
        task = null,
        file = null,
        project = null,
        access = [],
        deny = [],
      } = {}) => {
        let partial_permission = false;

        access.forEach((type) => {
          switch (type) {
            case "client":
              partial_permission = partial_permission || state.isClient;
              break;
            case "owner":
              partial_permission =
                partial_permission || task?.owner === state.user.id;
              break;
            case "file_owner":
              partial_permission =
                partial_permission || file.owner === state.user.id;
              break;
            case "assignees":
              partial_permission =
                partial_permission ||
                task.assignees.find(({ id }) => state.user.id === id) != null;

              break;
            case "user":
              partial_permission =
                partial_permission ||
                (!state.taskService.non_admin_permission &&
                  state.user.role === "user");

              break;

            default:
              break;
          }
        });

        partial_permission = partial_permission || state.user.role === "admin";

        deny.forEach((type) => {
          switch (type) {
            case "client":
              partial_permission = partial_permission && !state.isClient;
              break;
            case "whole":
              partial_permission = partial_permission && !state.isWhole;
              break;
            case "slave":
              let check_on = state.project.attributes;

              if (task) check_on = task;
              else if (project) check_on = project;

              partial_permission =
                partial_permission && !!!(check_on?.master_id ?? false);
              break;

            case "master":
              let check_on_ = state.project.slaves;

              if (task) check_on_ = task.slaves;
              else if (project) check_on_ = project.slaves;

              partial_permission = partial_permission && !check_on_.length;
              break;

            default:
              break;
          }
        });

        return partial_permission;
      },
    projects: (state) => JSON.parse(JSON.stringify(state.projects)),
    owner: (state) => {
      return {
        ...state.owner,
      };
    },
    user: (state) => {
      return {
        ...state.user,
      };
    },
    poject_count: (state) => state.count,

    kanban_view_data: (state) => {
      return state.kanban_view_data.filter(({ visible }) => visible);
    },
    archives_kanban_view_data_as_list: (state) => {
      let tasks_list = [];

      state.kanban_view_data.forEach(({ tasks }) => {
        tasks.forEach((task) => {
          if (JSON.parse(task.archivers).ids.includes(state.user.userID))
            tasks_list.push(task);
        });
      });

      return tasks_list;
    },

    kanban_view_data_as_list:
      (state) =>
      (type, filters = []) => {
        let tasks_list = [];
        const applyFilter = (task) => {
          let toReturn = true;
          for (let index = 0; index < filters.length; index++) {
            const element = filters[index];
          }
          switch (key) {
            case value:
              break;

            default:
              break;
          }
        };
        // JSON.parse(
        //   task.archivers ?? JSON.stringify({ ids: [] })
        // ).ids.includes(user.userID)

        switch (type) {
          case "category":
            let temp = { completed: [], incomplete: [] };
            state.kanban_view_data
              .filter(({ visible }) => visible)
              .forEach(({ tasks }) => {
                tasks.forEach((task) => {
                  if (task.is_completed) temp.completed.push(task);
                  else temp.incomplete.push(task);
                });
              });
            tasks_list = temp;
            break;
          case "request":
            state.kanban_view_data
              .filter(({ visible }) => visible)
              .forEach(({ tasks }) => {
                tasks.forEach((task) => {
                  if (task.isRequest) tasks_list.push(task);
                });
              });
            break;

          default:
            state.kanban_view_data
              .filter(({ visible }) => visible)
              .forEach(({ tasks }) => {
                tasks.forEach((task) => {
                  tasks_list.push(task);
                });
              });
            break;
        }

        return tasks_list;
      },
    kanban_view_data_columns: (state) => [
      ...state.kanban_view_data.map(({ tasks, ...rest }) => {
        return {
          ...rest,
          tasks_count: tasks.length,
        };
      }),
    ],
    kanban_view_data_loaded: (state) => state.kanban_view_data_loaded,

    timers: (state) => {
      return state.timers.filter((timer) => !timer.isClose);
    },

    newtab: (state) => state.newtab,

    newLogger: (state) => state.loggers,

    hasReload: (state) => state.startReload,

    realtimeSubscribed: (state) => state.realtimeSubscribed,
  },

  mutations: {
    // Raised whenever the "customer is waiting" state changed for this user, so
    // the views showing the "New replies" count re-read it. Tied to the state
    // change itself rather than to a UI event, which is easy to miss.
    PING_CLIENT_REPLY(state) {
      state.clientReplyPing++;
    },

    SET_REPLY_SNIPPETS_LOADING(state, { loading, projectId }) {
      state.reply_snippets = {
        ...state.reply_snippets,
        loading,
        projectId,
      };
    },

    SET_REPLY_SNIPPETS(state, { data, projectId }) {
      state.reply_snippets = {
        loaded: true,
        loading: false,
        projectId,
        data,
      };
    },

    RESET_REPLY_SNIPPETS(state) {
      state.reply_snippets = {
        loaded: false,
        loading: false,
        projectId: null,
        data: [],
      };
    },

    RELOAD_GET_RELOAD(state, status) {
      state.startReload = status;
    },

    SET_REALTIME_SUBSCRIBED(state, status) {
      state.realtimeSubscribed = status;
    },

    SET_DATE_LOGGER_FORMAT(state, format) {
      state.format = format;
    },
    UPDATE_LOGGER(state, newTimer) {
      state.timers = state.timers.map((timer) => {
        if (timer.id == newTimer.id) {
          timer.timeSpend = newTimer.time;
          timer.isRunning = newTimer.isRunning;
        }
        return timer;
      });
    },
    SET_TASK_TEMPLATES(state, task_templates) {
      state.task_templates = task_templates;
    },

    SET_TASKSERVICE(state, taskService) {
      state.taskService = taskService;
    },

    UPDATE_AUTH(state, data) {
      state.user = { ...state.user, ...data };
    },

    ADD_LOAD_TASKS_TABLE_VIEW(state, data) {
      const { tasks, update } = data;

      const queue = new Queue(tasks);

      let system = { data: state.kanban_view_data };

      const addTask = (task, index, state = system) => {
        const indexOfTask = state.data[index].tasks.findIndex((elmt) => {
          return elmt.step_id == task.step_id && elmt.id == task.id;
        });

        if (-1 == indexOfTask && !update)
          state.data[index].addTasks(task, 1, true, state.itemsPerPage);

        if (update && update.key == "step_id") {
          state.data[update.oldIndex].removeTask(task.id);
          state.data[update.newIndex].addTask(task);
        }

        if (state.data.sorted) state.data[index].sortTask();
      };

      while (!queue.isEmpty()) {
        const task = queue.dequeue();
        const index = system.data.findIndex((step) => step.id == task.step_id);
        addTask(task, index);
      }

      state.kanban_view_data = system.data;
    },

    ADD_LOAD_TASKS(state, data) {
      const { stepID, tasks, canBeLoad, page } = data;
      const newTasks = state.kanban_view_data.map((step) => {
        // if (
        //   (state.isWhole &&
        //     step.ids &&
        //     Array.isArray(step.ids) &&
        //     step.ids.includes(stepID)) ||
        //   step.id == stepID
        // )
        //   step.addTasks(tasks, page, canBeLoad, state.itemsPerPage);

        if (step.id != stepID) return step;

        const queue = new Queue(tasks);

        let system = step;

        const addTask = (task) => {
          const indexOfTask = system.tasks.findIndex((elmt) => {
            return elmt.id == task.id;
          });
          if (-1 == indexOfTask)
            system.addTasks(task, 1, true, state.itemsPerPage);

          if (state.sorted) system.sortTask();
        };

        while (!queue.isEmpty()) {
          addTask(queue.dequeue());
        }

        return system;
      });

      state.kanban_view_data = [...newTasks];
    },

    SET_FILTERS(state, types) {
      state.kanban_view_data.forEach((step) => {
        const cond = types.columnSelected.includes(step.id);

        step.updateProperty("visible", cond);
      });

      state.hasFilter =
        types.columnSelected.length < state.kanban_view_data.length;
    },

    STEP_LOADING(state, data) {
      const { stepID, status } = data;
      const newTasks = state.kanban_view_data.map((step) => {
        if (
          (state.isWhole &&
            step.ids &&
            Array.isArray(step.ids) &&
            step.ids.includes(stepID)) ||
          step.id == stepID
        )
          step.loading(status);

        if (state.sorted) step.sortTask();
        return step;
      });

      state.kanban_view_data = [...newTasks];
    },

    START_WORKER(state, data) {
      state.worker = new Worker("/worker.js");
    },

    UPDATE_TASK_COMPLETED(state, task) {
      const steps = state.kanban_view_data.map((step) => {
        if (
          (state.isWhole &&
            step.ids &&
            Array.isArray(step.ids) &&
            step.ids.includes(task.stepID)) ||
          step.id == task.stepID
        ) {
          const tasks = step.tasks.map((tt) => {
            if (tt.id == task.taskID) {
              return { ...tt, is_completed: true, isClosed: true };
            }
            return tt;
          });

          if (state.sorted) step.sortTask();

          return { ...step, tasks };
        }
        return step;
      });

      state.kanban_view_data = [...steps];
    },

    UPDATE_TASK_DEEP(state, task) {
      const steps = state.kanban_view_data.map((step) => {
        if (
          (state.isWhole &&
            step.ids &&
            Array.isArray(step.ids) &&
            step.ids.includes(task.step_id)) ||
          step.id == task.step_id
        ) {
          const tasks = step.tasks.map((tt) => {
            if (tt.id == task.id) {
              return task;
            }
            return tt;
          });

          if (state.sorted) step.sortTask();

          return { ...step, tasks };
        }
        return step;
      });

      state.kanban_view_data = steps;
    },

    OPEN_NEW_TAB(state, data) {
      state.newtab = data;
    },
    SET_CLIENTS(state, data) {
      state.clients = data;
    },
    SET_CLIENT(state, data) {
      state.client = data;
    },
    SET_IS_CLIENT(state, data) {
      state.isClient = data;
    },

    SET_PROJECTS(state, { data, adding = false }) {
      if (!adding) state.projects = data;
      else state.projects = [...state.projects, ...data];
    },

    SET_PROJECT_COUNT(state, data) {
      state.count = data;
    },

    SET_PROJECT(state, data) {
      state.project = data;
    },
    SET_OWNER(state, data) {
      state.owner = data;
    },
    SET_USER(state, data) {
      state.user = data;
    },
    SET_REQUEST_SETTINGS(state, parsedSettings) {
      state.requestSettings = parsedSettings;
    },
    UPDATE_REQUEST_SETTINGS(state, { property, value }) {
      state.requestSettings[property] = value;
    },

    UPDATE_REQUEST_CATEGORY(state, categories) {
      const temp = JSON.parse(JSON.stringify(state.requestSettings));
      temp.categories = categories;
      state.requestSettings = temp;
    },
    ADD_REQUEST_CATEGORY(state, category) {
      state.requestSettings.categories.push({
        ...category,
        index: state.requestSettings.categories.length,
        subcategories: category.subcategories.map((sub) => {
          return {
            ...sub,
            form: sub.form ?? [],
            db_id: sub.id,
            id: sub.subcategory,
          };
        }),
      });
    },
    SET_WHOLe(state, whole) {
      state.isWhole = whole;
    },
    ADD_TAG(state, tag) {
      state.tags.push(tag);
    },
    DELETE_TAG(state, tag_id) {
      // Remove tag from tags list
      state.tags = state.tags.filter(({ id }) => id !== tag_id);

      // Remove tag from all tasks in kanban view
      if (state.kanban_view_data && Array.isArray(state.kanban_view_data)) {
        state.kanban_view_data.forEach((step) => {
          if (step.tasks && Array.isArray(step.tasks)) {
            step.tasks.forEach((task) => {
              if (task.tags && Array.isArray(task.tags)) {
                task.tags = task.tags.filter((tag) => tag.id !== tag_id);
              }
            });
          }
        });
      }
    },
    SET_KANBANVIEW_DATA(state, data) {
      state.kanban_view_data = data;
    },
    ADD_TASK_COMMING_TO_CALENDAR(state, data) {
      const queue = new Queue(
        data.reduce((acc, step) => [...acc, ...step.tasks], [])
      );

      const addTask = (task, index) => {
        const taskFound = state.kanban_view_data[index].tasks.find(
          (tt) => tt.step_id == task.step_id
        );
        if (!taskFound) state.kanban_view_data[index].tasks.push(task);
      };

      while (!queue.isEmpty()) {
        const task = queue.dequeue();
        const index = state.kanban_view_data.findIndex((step) =>
          state.isWhole && step.ids && Array.isArray(step.ids)
            ? step.ids.includes(task.step_id)
            : step.id == task.step_id
        );
        addTask(task, index);
      }
    },

    SET_KANBANVIEW_DATA_LOADED(state, data) {
      state.kanban_view_data_loaded = data;
    },
    ADD_KANBAN_COLUMN(state, step) {
      state.kanban_view_data = [...state.kanban_view_data, step];
    },
    DELETE_KANBAN_COLUMN(state, stepID) {
      state.kanban_view_data = state.kanban_view_data.filter((step) =>
        state.isWhole && step.ids && Array.isArray(step.ids)
          ? step.ids.includes(task.step_id)
          : step.id != stepID
      );
    },

    UPDATE_TASK_GENERAL_SETTINGS(state, data) {
      const obj = data.type ? data : data["task reminder"];
      const settings = {
        ...state.generalSettings,
        [data.type ? data.type : "task reminder"]: { ...obj },
      };
      state.generalSettings = settings;
    },
    SET_TASK_GENERAL_SETTINGS(state, data) {
      state.generalSettings = data;
    },
    CHANGE_KANBAN_COLUMN_TASK_PROPERTY(
      state,
      { taskId, step_index, new_value, property }
    ) {
      state.kanban_view_data[step_index].tasks
        .find(({ id }) => id === taskId)
        ?.updateTask(property, new_value);

      if (state.sorted)
        state.kanban_view_data[step_index].sortTask(state.sorted);
    },

    CHANGE_KANBAN_COLUMN_TASK_COLUMN(
      state,
      {
        step_index,
        new_step_index,
        task_id,
        new_task,
        new_task_index,
        inListView,
      }
    ) {
      const { tasks, ...rest } = JSON.parse(
        JSON.stringify(state.kanban_view_data[new_step_index])
      );

      state.kanban_view_data[step_index].removeTask(task_id);

      state.kanban_view_data[new_step_index].addTask(
        new_task,
        "unshift",
        new_task_index,
        !inListView
      );
    },
    REMOVE_TASK_FROM_STEP(state, { step_index, task_id }) {
      state.kanban_view_data[step_index].removeTask(task_id);
    },
    SET_STEPS(state, data) {
      state.steps = data;
    },
    ADD_KANBAN_COLUMN_TASK(state, { task, column, callback }) {
      state.kanban_view_data.forEach((step) => {
        const { tasks, ...rest } = step;
        if (
          (state.isWhole &&
            rest.ids &&
            Array.isArray(rest.ids) &&
            rest.ids.includes(column)) ||
          rest.id == column
        ) {
          if (callback)
            callback({
              ...task,
              column: { ...rest, tasks_count: tasks.length },
            });
          step.addTask(task, "push", null, false, true);
          if (state.sorted) step.sortTask(state.sorted);
        }
      });
    },
    ADD_REQUEST_PIN(state, data) {
      state.requestSettings.pins.push({
        ...data,
        index: state.requestSettings.pins.length,
      });
    },
    UPDATE_REQUEST_PIN(state, { data, index }) {
      state.requestSettings.pins[index] = data;
    },

    DELETE_REQUEST_PIN(state, index) {
      state.requestSettings.pins.splice(index, 1);
    },

    UPDATE_KANBAN_COLUMN(state, { index, property, new_value }) {
      // Check if the column exists and has the updateProperty method
      if (state.kanban_view_data[index]) {
        if (
          typeof state.kanban_view_data[index].updateProperty === "function"
        ) {
          state.kanban_view_data[index].updateProperty(property, new_value);
        } else {
          // Fallback: directly set the property if updateProperty method doesn't exist
          state.kanban_view_data[index][property] = new_value;
        }
      }
    },

    DELETE_TASK(state, data) {
      const { stepID, taskID } = data;
      state.kanban_view_data.forEach((step) => {
        if (
          (state.isWhole &&
            step.ids &&
            Array.isArray(step.ids) &&
            step.ids.includes(stepID)) ||
          step.id == stepID
        ) {
          step.removeTask(taskID);
        }
        if (state.sorted) step.sortTask();
      });
    },

    UPDATE_TASK_SPEND_TIME(state, data) {
      const { stepID, taskID, time } = data;
      state.kanban_view_data.forEach((step) => {
        if (
          (state.isWhole &&
            step.ids &&
            Array.isArray(step.ids) &&
            step.ids.includes(stepID)) ||
          step.id == stepID
        ) {
          step.tasks.forEach((task) => {
            if (task.id == taskID) task.spentTime = time;
          });

          if (state.sorted) step.sortTask();
        }
      });
    },

    SET_PROJECT_FILES(state, data) {
      state.project_files = data;
    },

    DELETE_PROJECT_FILE(state, index) {
      state.project_files.splice(index, 1);
    },

    UPDATE_PROJECT_FILE(state, { value, index }) {
      state.project_files[index] = {
        ...state.project_files[index],
        ...value,
      };
    },

    SET_TAGS(state, data) {
      state.tags = data;
    },

    SET_USERS(state, data) {
      state.users = data;
    },
    SET_NEW_TIMER(state, data) {
      state.timers.push(data);
    },
    ADD_PROJECT(state, data) {
      state.projects = [data, ...state.projects];
    },
    UNSET_SET_NEW_TIMER(state, data) {
      const index = state.timer.indexOf(data);

      if (index > -1) {
        state.timers.splice(index, 1);
      }
    },
    UPDATE_PROJECT_RELATIONSHIP(state, { index, value, type }) {
      console.log("UPDATE_PROJECT_RELATIONSHIP mutation called:", {
        index,
        value,
        type,
      });
      let new_value = [];
      switch (type) {
        case "tags":
          new_value = value.map((p) => ({
            id: p.id,
            label: p.attributes ? p.attributes.label : p.label,
            variant: p.attributes ? p.attributes.variant : p.variant,
          }));
          break;
        case "assignees":
          new_value = value.map((item) => {
            // Handle both formats: with attributes and without
            if (item.attributes) {
              const { attributes } = item;
              return {
                id: attributes.userID,
                ID: item.id,
                email: attributes.email,
                firstName: attributes.first_name,
                phone: attributes.phone,
                lastName: attributes.last_name,
                role: attributes.role,
                title: `${attributes.first_name} ${attributes.last_name}`,
                alt: `${attributes.first_name} ${attributes.last_name}`,
                subTitle: attributes.email,
                background: attributes.color,
              };
            } else {
              // If no attributes, assume it's already in the right format
              return item;
            }
          });
          break;

        default:
          break;
      }

      console.log(
        "Updating project at index",
        index,
        "with",
        type,
        ":",
        new_value
      );
      state.projects[index].updateProperty(type, new_value);
      console.log("Project after update:", state.projects[index]);
    },

    LOAD_TIMERS(state, timers) {
      state.timers = timers;
    },

    UPDATE_TIMER(state, timer) {
      state.timers = state.timers.map((t) => {
        if (t.id == timer.id) return timer;
        else return t;
      });

      if (!timer.isClose) return false;

      state.timers = state.timers.filter((t) => !t.isClose);

      const steps = state.kanban_view_data.map((step) => {
        if (
          (state.isWhole &&
            step.ids &&
            Array.isArray(step.ids) &&
            step.ids.includes(timer.task.stepID)) ||
          step.id == timer.task.stepID
        ) {
          const tasks = step.tasks.map((tt) => {
            if (tt.id == timer.task.id) tt.spentTime = timer.task.spentTime;

            return tt;
          });

          return { ...step, tasks };
        }

        return step;
      });

      state.kanban_view_data = [...steps];
    },

    SET_PROJECTS_LOADER(state, val) {
      state.projects_loading = val;
    },

    SET_PROJECTS_NEXT_PAGE(state, page) {
      state.nextProjectPage = page;
    },

    REMOVE_TIMER(state, timerID) {
      state.timers = state.timers.filter((t) => t.id != timerID);
    },

    DELETE_PROJECT(state, index) {
      state.projects.splice(index, 1);
    },

    DELETE_PROJECTS(state, ids) {
      state.projects = state.projects.filter((p) => !ids.includes(p.id));
    },

    UPDATE_PROJECT(state, data) {
      state.projects.splice(data.index, 1, data.project);
    },

    UPDATE_PROJECT_STATUS(state, data) {
      const projects = state.projects.map((project) => {
        if (project.id == data.project.id) return data.project;
        return { ...project, isActif: false };
      });

      state.projects = projects;
    },

    ADD_LOGGER(state, logger) {
      state.loggers = { ...logger, isClose: true };
    },

    SET_NOTIFICATIONS(state, data) {
      if (data.status == false) {
        state.unread_notifications = data.notifications;
      } else if (data.status == true) {
        state.read_notifications = data.notifications;
      } else {
        state.notifications = data.notifications;
      }
    },
    APPEND_NOTIFICATIONS(state, data) {
      if (data.status == false) {
        state.unread_notifications = [
          ...state.unread_notifications,
          ...data.notifications,
        ];
      } else {
        state.read_notifications = [
          ...state.read_notifications,
          ...data.notifications,
        ];
      }
    },
    INCREMENT_PAGE(state, data) {
      if (data.status == false) {
        state.unread_nextPage = data.next;
        state.unread_currentPage++;
      } else {
        state.read_nextPage = data.next;
        state.read_currentPage++;
      }
    },

    CLEAR_LOGGER(state, logger) {
      state.loggers = null;
    },

    UPDATE_FILTER(state, filter) {
      state.filtersNotifications = filter;
    },

    ADD_SORTED(state, data) {
      state.sorted = data;
      state.kanban_view_data = state.kanban_view_data.map((step) => {
        if (step instanceof Step) {
          step.sortTask(data);
          return step;
        } else {
          const newStep = new Step(step);
          newStep.sortTask(data);
          return newStep;
        }
      });
    },

    SET_COMMENT_SORT(state, sortOrder) {
      state.commentSort = sortOrder;
    },
  },

  actions: {
    /**
     * Loads the project's canned replies (reply snippets).
     *
     * Safe to call from every comment editor that mounts: it returns the cached
     * list unless the project changed, so opening ten tasks in a row issues a
     * single request. A failure resolves to an empty list -- an unavailable
     * snippet list must never stop someone from commenting.
     */
    fetchReplySnippets({ commit, state }, projectId) {
      const id = projectId || (state.project && state.project.id);
      if (!id) return Promise.resolve([]);

      const current = state.reply_snippets;
      if (current.loading) return Promise.resolve(current.data);
      if (current.loaded && current.projectId == id)
        return Promise.resolve(current.data);

      commit("SET_REPLY_SNIPPETS_LOADING", { loading: true, projectId: id });

      return axiosGet(
        `${CREATE_EMAIL_SNIPPET}?filter[project_id]=${id}&filter[snippet_type]=reply&no_pagination=1`
      )
        .then((res) => {
          const snippets = new QuerySnippet(res.data.data)
            .run()
            .filter((snippet) => snippet.status);

          commit("SET_REPLY_SNIPPETS", { data: snippets, projectId: id });
          return snippets;
        })
        .catch((e) => {
          console.log(e);
          commit("SET_REPLY_SNIPPETS", { data: [], projectId: id });
          return [];
        });
    },

    /**
     * Call after creating/updating/deleting a reply snippet so the editors pick
     * the change up without a page reload.
     */
    reloadReplySnippets({ commit, dispatch, state }) {
      const id = state.project && state.project.id;
      commit("RESET_REPLY_SNIPPETS");
      return dispatch("fetchReplySnippets", id);
    },

    removeTimer({ commit }, timer) {
      commit("REMOVE_TIMER", timer);
    },
    updateTimer({ commit }, timer) {
      commit("UPDATE_TIMER", timer);
    },

    loadTimers({ commit }, timers) {
      commit("LOAD_TIMERS", timers);
    },

    /**
     * Re-reads the current user's open timers for the active project and swaps
     * them into the store. Used after a task is created in a project that has
     * `auto_start_timer` on: the backend opened the timer, this makes the
     * floating widget appear without waiting for a full page reload.
     */
    reloadTimers({ commit, state }) {
      if (!state.user || !state.project || !state.project.id) return;

      return axiosGet(
        `${CREATE_LOG_TIMER}?filter[task_user_id]=${state.user.id}&no_pagination=1&filter[has_been_close]=0&filter[project_id]=${state.project.id}`
      )
        .then((res) => {
          const loggers = new QueryLogTimer(res.data.data, state.project);
          commit("LOAD_TIMERS", loggers.run());
        })
        .catch((e) => {
          console.log(e);
        });
    },

    async fetch_task_templates({ commit }, email) {
      await axiosGet(
        `${BASE_TASK}/list_task_template?user_email=${email}&take_all=yes`
      )
        .then((res) => {
          commit("SET_TASK_TEMPLATES", res.data);
        })
        .catch((e) => {
          console.log(e);
          return e;
        });
    },

    async fetch_read_notifications({ commit, state }, data) {
      const params = state.filtersNotifications.reduce((acc, filter) => {
        if (acc) acc = `${acc}|${filter}`;
        else acc = `${filter}`;

        return acc;
      }, "");

      if (data.action == "refresh") {
        state.read_currentPage = 1;
        commit("UPDATE_FILTER", []);
      }

      if (data.action == "filter") {
        state.read_currentPage = 1;
        state.loadingNotification = true;
      }

      let filter = params ? `&filter[models]=${params}` : "";

      filter += data.query ? `&filter[query]=${data.query}` : "";

      const notificationURL = `${BASE_TASK}/notifications?filter[has_been_read]=1&page=${state.read_currentPage}${filter}`;

      if (
        state.read_currentPage === 1 ||
        (state.read_currentPage > 1 && state.read_nextPage != null)
      ) {
        return await axiosGet(notificationURL)
          .then((res) => {
            const notifs = new QueryNotifications(res.data.data);

            if (state.read_currentPage === 1) {
              commit("SET_NOTIFICATIONS", {
                notifications: notifs.run(),
                status: true,
              });
            } else {
              commit("APPEND_NOTIFICATIONS", {
                notifications: notifs.run(),
                status: true,
              });
            }

            if (res.data != null && res.data.data.length >= 1)
              commit("INCREMENT_PAGE", {
                next: res.data.links.next,
                status: true,
              });

            return res.data.data.length ? true : false;
          })
          .catch((e) => {
            console.log(e);
            return e;
          })
          .finally(() => (state.loadingNotification = false));
      }
    },

    async fetch_unread_notifications({ commit, state }, data) {
      const params = state.filtersNotifications.reduce((acc, filter) => {
        if (acc) acc = `${acc}|${filter}`;
        else acc = `${filter}`;
        return acc;
      }, "");

      if (data.action == "refresh") {
        state.unread_currentPage = 1;
        commit("UPDATE_FILTER", []);
      }

      if (data.action == "filter") {
        state.unread_currentPage = 1;
        state.loadingNotification = true;
      }

      let filter = params ? `&filter[models]=${params}` : "";

      filter += data.query ? `&filter[query]=${data.query}` : "";

      const notificationURL = `${BASE_TASK}/notifications?filter[has_been_read]=0&page=${state.unread_currentPage}${filter}`;

      if (
        state.unread_currentPage === 1 ||
        (state.unread_currentPage > 1 && state.unread_nextPage != null)
      ) {
        return await axiosGet(notificationURL)
          .then((res) => {
            const notifs = new QueryNotifications(res.data.data);

            if (state.unread_currentPage === 1) {
              commit("SET_NOTIFICATIONS", {
                notifications: notifs.run(),
                status: false,
              });
            } else {
              commit("APPEND_NOTIFICATIONS", {
                notifications: notifs.run(),
                status: false,
              });
            }

            if (res.data != null && res.data.data.length >= 1)
              commit("INCREMENT_PAGE", {
                next: res.data.links.next,
                status: false,
              });

            return res.data.data.length ? true : false;
          })
          .catch((e) => {
            console.log(e);
            return [];
          })
          .finally(() => (state.loadingNotification = false));
      }
    },

    async update_notification_read_status({ state }, data) {
      await axiosPatch(
        `${BASE_TASK}/notifications/${data.notificationId}`,
        data.data
      )
        .then((res) => {
          if (data.data_type == "all") {
            //
          } else if (data.data_type == "item") {
            if (data.data_value) {
              let unread_notification = state.unread_notifications.find(
                ({ id }) => id == data.notificationId
              );
              unread_notification.updateNotification(
                "has_read",
                data.data_value
              );
              let indexToRemove = state.unread_notifications.findIndex(
                (obj) => obj.id === unread_notification.id
              );

              if (indexToRemove !== -1) {
                state.unread_notifications.splice(indexToRemove, 1);
                state.read_notifications.push(unread_notification);
              }
            } else {
              let read_notification = state.read_notifications.find(
                ({ id }) => id == data.notificationId
              );
              read_notification.updateNotification("has_read", data.data_value);
              let indexToRemove = state.read_notifications.findIndex(
                (obj) => obj.id === read_notification.id
              );

              if (indexToRemove !== -1) {
                state.read_notifications.splice(indexToRemove, 1);
                state.unread_notifications.push(read_notification);
              }
            }
          }
        })
        .catch((e) => {
          console.log(e);
          return e;
        });
    },

    async delete_notification({ state }, { notificationId, status }) {
      return axiosDelete(`${BASE_TASK}/notifications/${notificationId}`)
        .then(() => {
          // Remove from the appropriate list
          if (status === 'unread') {
            const idx = state.unread_notifications.findIndex(n => n.id === notificationId);
            if (idx !== -1) state.unread_notifications.splice(idx, 1);
          } else {
            const idx = state.read_notifications.findIndex(n => n.id === notificationId);
            if (idx !== -1) state.read_notifications.splice(idx, 1);
          }
        })
        .catch((e) => {
          console.log(e);
          throw e;
        });
    },

    // NOTE: this action rejects on failure instead of resolving to []. Swallowing
    // the error made a failed/timed-out request indistinguishable from "this task
    // has no time log": the panel showed "No time logs yet" and the caller then
    // wrote a spentTime of 0 over the correct value on the kanban card.
    // Every caller must handle the rejection and keep the previous total.
    fetch_logs(_, { task_id, data, filters }) {
      const fetch = task_id
        ? axiosGet(
            `${CREATE_LOG_TIMER}?filter[task_id]=${task_id}&filter[has_been_close]=${filters.close}&no_pagination=1`,
            data
          )
        : axiosGet(`api/task/loggers?no_pagination=1`, data);
      return fetch.then((res) => {
        const loggers = new QueryLogTimer(res.data.data, this.project);
        return loggers.run();
      });
    },

    fetch_logs_by_clients(_, { client_id, data }) {
      const fetch = client_id
        ? axiosGet(
            `api/task/clients/${client_id}/relationships/loggers?no_pagination=1`,
            data
          )
        : axiosGet(
            `api/task/clients/relationships/loggers?no_pagination=1`,
            data
          );
      return fetch
        .then((res) => {
          const loggers = new QueryLogTimer(res.data.data, this.project);
          return loggers.run();
        })
        .catch((e) => {
          console.log(e);
          return [];
        });
    },

    change_kanban_column_task_property(
      _,
      { callback, errorCallback, data, taskId, warningCallback }
    ) {
      axiosPatch(`${CREATE_TASK}/${taskId}`, data)
        .then((res) => {
          callback(res.data);
          if (res.headers["message"])
            warningCallback(JSON.parse(res.headers["message"]));
        })
        .catch((e) => {
          console.log(e);
          errorCallback(e);
        });
    },

    change_kanban_column_task_relationship(
      { commit },
      { callback, data, taskId, type }
    ) {
      return axiosPatch(
        `${CREATE_TASK}/${taskId}/relationships/${type}`,
        data
      ).then(
        (res) => {
          return callback(res.data.data.relationships[type].data);
        },
        (err) => console.log(err)
      );
    },

    change_kanban_column_task_column(
      { commit, state },
      {
        taskId,
        data,
        step_index,
        new_task_index,
        new_step_index,
        isSubbtask,
        warningCallback,
        callback,
        inListView,
      }
    ) {
      return axiosPatch(`${CREATE_TASK}/${taskId}`, data).then(
        ({ data, headers }) => {
          if (headers["message"])
            warningCallback(JSON.parse(headers["message"]));
          const { tasks, ...rest } = state.kanban_view_data[step_index] ?? {};

          const new_task = {
            added: data.data.attributes.added,
            put_to_step_at: data.data.attributes.put_to_step_at,
            put_to_step: data.data.attributes.put_to_step,
            created_at: data.data.attributes.created_at,
            updated_at: data.data.attributes.updated_at,
            started_at: data.data.attributes.started_at,
            due_date: data.data.attributes.closed_at,
            archivers: data.data.attributes.archivers,
            request_data: data.data.attributes.request_data,
            requestSettings: state.requestSettings,
            project_name: data.data.attributes.project_name,
            ticket_number: data.data.attributes.ticket_number,
            generalSettings: state.generalSettings,
            files_number: data.data.attributes.files_number,
            comments_number: data.data.attributes.comments_number,
            subtasks_number: data.data.attributes.subtasks_number,
            incomplete_subtasks_number:
              data.data.attributes.incomplete_subtasks_number,
            is_completed: data.data.attributes.is_completed,
            is_closed: data.data.attributes.is_closed,
            task_system_id: data.data.attributes.task_system_id,
            title: data.data.attributes.title,
            approval_stage: data.data.attributes.approval_stage,
            is_request: data.data.attributes.is_request,
            is_form: data.data.attributes.is_form,
            cron_expression:
              data.data.relationships.schedules.data[0]?.attributes.frequency,
            description: data.data.attributes.description,
            step_id: data.data.attributes.step_id,
            owner: data.data.attributes.task_user_id,
            id: data.data.id,
            is_follow: data.data.attributes.is_follow,
            spentTime: data.data.attributes.spent_time,
            projectId: data.data.relationships.steps.data.attributes.project_id,
            slaves: data.data.relationships.slaves.data.map(
              ({ attributes, id }) => {
                return {
                  id,
                  ...attributes,
                };
              }
            ),

            master:
              data.data.relationships.master.length === undefined
                ? data.data.relationships.master.data[0]
                : null,

            assignees: data.data.relationships.assignees.data.map(
              ({ attributes, id }) => {
                return {
                  id,
                  title: `${attributes.first_name} ${attributes.last_name}`,
                  alt: `${attributes.first_name} ${attributes.last_name}`,
                  subTitle: attributes.email,
                  background: attributes.color,
                };
              }
            ),
            clients: data.data.relationships.clients.data.map(
              ({ attributes, id }) => {
                return {
                  id,
                  userID: attributes.userID,
                  locationId: attributes.locationId,
                  title: `${attributes.firstName} ${attributes.lastName}`,
                  alt: `${attributes.firstName} ${attributes.lastName}`,
                  subTitle: attributes.email,
                  background: attributes.color,
                  phone: attributes.phone,
                  account: attributes.account,
                  sub_account_name: attributes.sub_account_name,
                };
              }
            ),
            tags: data.data.relationships.tags.data.map((p) => ({
              id: p.id,
              label: p.attributes.label,
              variant: p.attributes.variant,
            })),
            priority: data.data.attributes.priority,
            estimated_time: data.data.attributes.estimated_time,
            column: { ...(rest ?? {}), tasks_count: tasks?.length ?? 0 },
          };

          if (isSubbtask) {
            if (callback) callback();
            return new_task;
          } else {
            commit("CHANGE_KANBAN_COLUMN_TASK_COLUMN", {
              step_index,
              task_id: taskId,
              new_task,
              new_step_index,
              new_task_index,
              inListView,
            });
            if (callback) callback();

            return {};
          }
        },
        (err) => console.log(err)
      );
    },

    moveColumn({ state }) {
      const columns = state.kanban_view_data.map(({ tasks, ...rest }) => {
        return {
          ...rest,
          tasks_count: tasks.length,
        };
      });

      const type = "task settings";
      const generalSettings = state.generalSettings;

      if (!generalSettings || !generalSettings.hasOwnProperty(type))
        return false;

      const moveColumnID = generalSettings[type].content;

      const moveColumn = columns.find((column) => column.id == moveColumnID);

      if (!moveColumn) return false;
      return moveColumn;
    },

    async create_task_from_template({ commit, state }, data) {
      return await axiosPost(
        BASE_TASK + "/create_task_from_template?user_email=" + data.user_email,
        {
          template: data.template,
          project: data.project,
          column_id: data.column_id,
          // Scalar overrides — backend uses template values as defaults and lets these win
          title: data.title,
          description: data.description,
          priority: data.priority,
          estimated_time: data.estimated_time,
          started_at: data.started_at,
          closed_at: data.closed_at,
        }
      )
        .then((res) => {
          res.data.data.attributes.archivers = JSON.stringify({ ids: [] });

          const { tasks, ...column } = JSON.parse(
            JSON.stringify(
              state.kanban_view_data.find(({ id, ids }) =>
                state.isWhole && ids && Array.isArray(ids)
                  ? ids.includes(res.data.data.attributes.step_id)
                  : id === res.data.data.attributes.step_id
              )
            )
          );

          const make = new CommandCreateTask(
            {
              ...res.data.data,
              column,
            },
            {
              requestSettings: state.requestSettings,
              generalSettings: state.generalSettings,
            }
          );
          const task_make = make.execute();
          commit("ADD_KANBAN_COLUMN_TASK", {
            task: task_make,
            column: res.data.data.attributes.step_id,
            callback: null,
          });
          return res;
        })
        .catch(({ response }) => {
          console.log(response);
          throw new Error(response.data.message);
        });
    },
    //unarchive
    add_kanban_column_task({ commit, dispatch, state }, { data, callback }) {
      return axiosPost(CREATE_TASK, data)
        .then(async (res) => {
          res.data.data.attributes.archivers = JSON.stringify({ ids: [] });

          const { tasks, ...column } = JSON.parse(
            JSON.stringify(
              state.kanban_view_data.find(({ id, ids }) =>
                state.isWhole && ids && Array.isArray(ids)
                  ? ids.includes(res.data.data.attributes.step_id)
                  : id === res.data.data.attributes.step_id
              )
            )
          );

          const make = new CommandCreateTask(
            {
              ...res.data.data,
              column,
            },
            {
              requestSettings: state.requestSettings,
              generalSettings: state.generalSettings,
            }
          );
          const task_make = make.execute();
          commit("ADD_KANBAN_COLUMN_TASK", {
            task: task_make,
            column: res.data.data.attributes.step_id,
            callback,
          });

          // The project may have auto-started a timer for this task server-side.
          if (res.data.meta && res.data.meta.started_timers) {
            dispatch("reloadTimers");
          }
        })
        .catch((error) => {
          console.log(error);
          throw error.response ?? error;
        });
    },

    update_kanban_column({ commit }, params) {
      const { id, data, index, property } = params;

      return axiosPatch(`${CREATE_COLUMN}/${id}`, data)
        .then((res) => {
          commit("UPDATE_KANBAN_COLUMN", {
            index,
            property,
            new_value: data.data.attributes.title,
          });

          commit("UPDATE_KANBAN_COLUMN", {
            index,
            property: "color",
            new_value: data.data.attributes.color,
          });

          commit("UPDATE_KANBAN_COLUMN", {
            index,
            property: "position",
            new_value: data.data.attributes.position,
          });
        })
        .catch((e) => {
          console.log(e);
          throw new Error(e);
        });
    },

    delete_task_column({ commit, state }, params) {
      const { stepID, taskID } = params;

      return axiosDelete(`${CREATE_TASK}/${taskID}`).then((res) => {
        commit("DELETE_TASK", { stepID, taskID });
        return res;
      });
    },

    delete_kanban_column({ commit }, stepID) {
      return axiosDelete(`${CREATE_COLUMN}/${stepID}`).then((e) => {
        commit("DELETE_KANBAN_COLUMN", stepID);
        return e;
      });
    },

    add_kanban_column({ commit, state }, data) {
      return axiosPost(CREATE_COLUMN, data)
        .then((res) => {
          const make = new CommandCreateStep({
            ...res.data.data,
            index: state.kanban_view_data.length,
          });
          commit("ADD_KANBAN_COLUMN", make.execute());
          return res;
        })
        .catch((e) => {
          console.log(e);
          throw e;
        });
    },

    load_sub_tasks(_, taskId) {
      return axiosGet(`${CREATE_TASK}/${taskId}/subtasks`);
    },

    load_kanban_view({ commit, state, dispatch }) {
      if (state.kanban_view_data_loaded) {
        commit("SET_KANBANVIEW_DATA_LOADED", false);
        commit("SET_KANBANVIEW_DATA", []);
      }
      let filters = {};
      let searchParams = "";
      if (state.isClient) {
        filters["filter[clients.locationId]"] = state.client?.locationId;
        filters["filter[request_data]"] = ":isNotNull";
        searchParams = "?" + new URLSearchParams(filters);
      } else if (
        state.taskService.non_admin_permission &&
        state.user.role === "user"
      ) {
        // filters[
        //   "filter[search]"
        // ] = `assignees:${state.user.id}|request_data:isNotNull`;
                  filters["filter[search]"] = `assignees:${state.user.id}`;
        // params["filter[request_data]"] = ":isNotNull";

        searchParams = "?" + new URLSearchParams(filters);
      }

      let kanban_view_data_url = `${ALLTASK}/${state.project.id}`;

      const taskID = new URL(location.href).searchParams.get("keyclock");

      const singleTask = (taskID, steps) =>
        axiosGet(`${CREATE_TASK}/${taskID}`)
          .then((res) => {
            const make = new CommandCreateTask(res.data.data, {
              requestSettings: state.requestSettings,
              generalSettings: state.generalSettings,
            })?.execute();

            if (!make) {
              state.kanban_view_data = steps;
              return false;
            }

            state.kanban_view_data = steps.map((step) => {
              if (step.id == make.step_id) {
                const taskExist = step.tasks.findIndex(
                  (task) => task.id == make.id
                );
                if (-1 == taskExist) step.tasks.push(make);
              }
              return step;
            });
          })
          .catch((e) => {
            console.log(e);
          })
          .finally((e) => commit("SET_KANBANVIEW_DATA_LOADED", true));

      if (state.isWhole) {
        kanban_view_data_url = "api/task/steps/all/tasks";
      }

      axiosGet(`${kanban_view_data_url}${searchParams}`)
        .then((res) => {
          const make = new QueryColumns(res.data.data, {
            requestSettings: state.requestSettings,
            generalSettings: state.generalSettings,
          });

          if (state.isWhole) {
            commit(
              "SET_STEPS",
              res.data.project.map((pj) => {
                return {
                  ...pj,
                  index: res.data.data.findIndex((st) =>
                    st.ids.includes(pj.id)
                  ),
                };
              })
            );
          }

          if (taskID) {
            singleTask(taskID, make?.run());
          } else {
            commit("SET_KANBANVIEW_DATA", make?.run());
            commit("SET_KANBANVIEW_DATA_LOADED", true);
          }

          // Subscribe to real-time updates after kanban view loads
          dispatch("subscribeToRealtime");
        })
        .catch((e) => {
          console.log(e);
        });
    },

    load_tags({ commit, state }, { type, id }) {
      axiosGet(`${CREATE_TAG}${type && id ? `?filter[${type}]=${id}` : ""}`)
        .then((res) => {
          state.itemsPerPage = state.itemsPerPage
            ? state.itemsPerPage
            : res?.data?.meta?.per_page ?? 12;
          commit(
            "SET_TAGS",
            res?.data?.data?.map((p) => ({
              id: p.id,
              appears: p.attributes.appears,
              label: p.attributes.label,
              variant: p.attributes.variant,
            })) || []
          );
        })
        .catch((e) => {
          console.log(e);
        });
    },

    load_project_tags({ state }) {
      return axiosGet(`${CREATE_TAG}?filter[project_id]=${state.project.id}`);
    },

    openNewTab({ commit }, data) {
      commit("OPEN_NEW_TAB", data);
    },

    startNewTimer({ commit }, data) {
      commit("SET_NEW_TIMER", data);
    },

    stopNewTimer({ commit }, data) {
      commit("UNSET_SET_NEW_TIMER", data);
    },

    load_users({ commit, state }, data = {}) {
      let action = data.action ?? "any";
      commit("SET_USERS", {
        loaded: false,
        error: false,
        data: [],
      });

      if (state.project_users.length > 0) {
        let users = state.project_users;
        if (action != "Add People") {
          users = users.filter((u) => u.id !== state.user.userID);
        }
        users = users.map((u) => ({
          id: u.id,
          title: `${u.firstName} ${u.lastName}`,
          subTitle: u.email,
          email: u.email,
          firstName: u.firstName,
          phone: u.phone,
          lastName: u.lastName,
          role: u.roles.role,
          roleType: u.roles.type,
          background: u.color,
        }));

        commit("SET_USERS", {
          loaded: true,
          error: false,
          data: users,
        });
      } else {
        axiosGet(ACCOUNTS_PROJECT)
          .then(({ data }) => {
            let users = data;
            state.project_users = data;
            if (action != "Add People") {
              users = users.filter((u) => u.id !== state.user.userID);
            }
            users = users.map((u) => ({
              id: u.id,
              title: `${u.firstName} ${u.lastName}`,
              subTitle: u.email,
              email: u.email,
              firstName: u.firstName,
              phone: u.phone,
              lastName: u.lastName,
              role: u.roles.role,
              roleType: u.roles.type,
              background: u.color,
            }));

            commit("SET_USERS", {
              loaded: true,
              error: false,
              data: users,
            });
          })
          .catch((e) => {
            commit("SET_USERS", {
              loaded: true,
              error: true,
              data: [],
            });

            console.log(e);
          });
      }
    },

    load_task_files(_, data) {
      return axiosGet(`${CREATE_TASK}/${data}/files`)
        .then(({ data }) => {
          return data.data.map(({ id, attributes, relationships }, index) => {
            const { users, tasks, tags } = relationships;

            return {
              ...attributes,
              id,
              index,
              tasks: tasks.data.map((task) => {
                return { id: task.id };
              }),
              tags: tags.data.map((tag) => {
                return {
                  id: tag.id,
                  ...tag.attributes,
                };
              }),
              // comments: relationships.file_comments.data,
              owner: {
                id: users.data.id,
                ...users.data.attributes,
              },
            };
          });
        })
        .catch((e) => {
          console.log(e);
          return [];
        });
    },
    load_project_clients({ state, commit }, id) {
      axiosGet(
        `${CREATE_PROJECT}/${
          state.isWhole ? "" : id
        }/relationships/clients?no_paginate=1`
      )
        .then(({ data }) => {
          const users = data.data.map(({ id, attributes }) => ({
            id,
            title: `${attributes.firstName} ${attributes.lastName}`,
            subTitle: attributes.email,
            email: attributes.email,
            firstName: attributes.firstName,
            phone: attributes.phone,
            lastName: attributes.lastName,
            account: attributes.account,
            sub_account_name: attributes.sub_account_name,
            locationId: attributes.locationId,
            background: attributes.color,
            all_client_ids: attributes.all_client_ids || [id],
          }));
          commit("SET_CLIENTS", users);
        })
        .catch((e) => {
          console.log(e);
        });
    },
    delete_file(_, id) {
      return axiosDelete(`/api/task/files/${id}`);
    },

    create_project({ commit, state }, data) {
      return axiosPost(`${CREATE_PROJECT}`, data).then((res) => {
        // Since ADD_PROJECT prepends the project (adds to beginning), index should be 0
        const make = new QueryProject({
          ...res.data.data,
          index: 0,
        });
        const project = make.run();
        commit("ADD_PROJECT", project);

        // Update all project indices
        state.projects.forEach((p, idx) => {
          p.index = idx;
        });
      });
    },

    onLoad({ commit, state }, params) {
      state.projectIsLoading = true;
      state.nextProjectPage = state.nextProjectPage + 1;

      // Include active project ID if available in state
      const requestParams = {
        ...params,
        sort: "-id",
        page: state.nextProjectPage,
      };

      // Add active project ID to maintain consistent ordering across pages
      if (state.project && state.project.id) {
        requestParams.active_project_id = state.project.id;
      }

      axiosGet(`${CREATE_PROJECT}`, {
        params: requestParams,
      })
        .then((res) => {
          if (!res.data.data.length) {
            state.projectCanBeLoad = false;
            state.projectIsLoading = false;
            return false;
          }
          const projects = res.data.data.map((p, index) =>
            new QueryProject({
              ...p,
              index,
            }).run()
          );

          state.projectCanBeLoad = projects.length < 10 ? false : true;
          state.projectIsLoading = false;

          commit("SET_PROJECTS", { data: projects, adding: true });
          commit("SET_PROJECT_COUNT", res.data.meta.total);
          commit("SET_PROJECTS_LOADER", false);
        })
        .catch((e) => {
          console.log(e);
        });
    },

    searchProject({ commit, state }, params) {
      state.projects_loading = true;
      state.projectCanBeLoad = true;

      commit("SET_PROJECTS_LOADER", true);

      state.projectIsLoading = true;
      axiosGet(`${CREATE_PROJECT}`, {
        params: {
          sort: "-id",
          ...params,
        },
      })
        .then((res) => {
          state.itemsPerPage = res.data.meta.per_page;
          const projects = res.data.data.map((p, index) =>
            new QueryProject({
              ...p,
              index,
            }).run()
          );

          if (!projects.length || projects.length < state.itemsPerPage)
            state.projectCanBeLoad = false;

          commit("SET_PROJECTS", { data: projects });
          commit("SET_PROJECT_COUNT", res.data.meta.total);
          commit("SET_PROJECTS_LOADER", false);
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          state.projectIsLoading = false;
        });
    },

    load_projects({ commit, state }, data) {
      state.projects_loading = true;
      state.projectCanBeLoad = true;

      commit("SET_PROJECTS_LOADER", true);

      state.projectIsLoading = true;

      // Support both string (locationId) and object (with active_project_id) formats
      const locationId = typeof data === 'string' ? data : data.locationId || data;
      const activeProjectId = typeof data === 'object' ? data.active_project_id : null;

      const params = {
        "filter[locationId]": locationId,
        sort: "-id",
      };

      // Add active project ID to prioritize it in results
      if (activeProjectId) {
        params.active_project_id = activeProjectId;
      }

      axiosGet(`${CREATE_PROJECT}`, { params })
        .then((res) => {
          state.itemsPerPage = res.data.meta.per_page;
          const projects = res.data.data.map((p, index) =>
            new QueryProject({
              ...p,
              index,
            }).run()
          );

          if (!projects.length || projects.length < state.itemsPerPage)
            state.projectCanBeLoad = false;

          commit("SET_PROJECTS", { data: projects });
          commit("SET_PROJECT_COUNT", res.data.meta.total);
          commit("SET_PROJECTS_LOADER", false);
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          state.projectIsLoading = false;
        });
    },

    clone_project({ commit, state }, projectID) {
      return axiosGet(`${CREATE_PROJECT}/clone/${projectID}`, {})
        .then((res) => {
          const make = new QueryProject({
            ...res.data.data,
            index: state.projects.length,
          });
          const project = make.run();
          commit("ADD_PROJECT", project);
          return project;
        })
        .catch((e) => {
          console.log(e);
        });
    },

    share_project(_, data) {
      return axiosPost(`${CREATE_PROJECT}/share/${data.projectID}`, {
        keys: data.keys,
      });
    },

    delete_tag({ commit }, id) {
      return axiosDelete(`${CREATE_TAG}/${id}`);
    },

    create_tag({ state }, { tag }) {
      const data = {
        data: {
          type: "tags",
          attributes: {
            ...tag,
            task_user_id: state.user.id,
          },
        },
      };

      return axiosPost(CREATE_TAG, data);
    },

    update_slaves_project_relationship(_, { type, data, project }) {
      let url = "";

      switch (type) {
        case "tags":
          url = `${CREATE_PROJECT}/${project.id}/relationships/${type}`;
          break;
        case "assignees":
          url = `${CREATE_PROJECT}/${project.id}/relationships/assignees`;
          break;
        default:
          break;
      }

      axiosPatch(url, data);
    },

    update_project_relationship(
      { commit, state, dispatch },
      { type, projectId, id_to_delete, id_to_add, all, callback }
    ) {
      // Find the project index from projectId
      const index = state.projects.findIndex((p) => p.id === projectId);
      if (index === -1) {
        console.error("Project not found with id:", projectId);
        return;
      }
      let data = {
        data: [],
      };
      let url = "";

      switch (type) {
        case "tags":
          url = `${CREATE_PROJECT}/${state.projects[index].id}/relationships/${type}`;
          const newProp = state.projects[index][type].filter(
            ({ id }) => id !== id_to_delete
          );
          data.data = [...newProp, ...id_to_add].map(({ id }) => {
            return {
              type,
              id,
            };
          });

          break;
        case "assignees":
          // Only use relationship API for removal operations (when we have Laravel IDs)
          // For add/update operations from modal, the patch API should be used
          if (id_to_delete && !id_to_add && !all) {
            // This is a removal operation from table view - use relationship API
            url = `${CREATE_PROJECT}/${state.projects[index].id}/relationships/assignees`;

            // Remove the deleted assignee and sync the rest
            const remaining = state.projects[index].assignees.filter(
              ({ id }) => id !== id_to_delete
            );

            // Format data for relationships endpoint (sync operation)
            data = {
              data: remaining.map((assignee) => ({
                type: "users",
                id: assignee.id || assignee.ID || assignee.userID,
              })),
            };
          } else if (all) {
            // This is from the modal - but we should not use relationship API
            // The patch API should have already been called with assignees in attributes
            console.log(
              "Assignees should be handled via patch API, not relationship API"
            );
            return Promise.resolve(); // Don't make another API call
          }
          break;
        default:
          break;
      }

      state.projects[index].slaves.forEach((s) => {
        dispatch("update_slaves_project_relationship", {
          type,
          data,
          project: s,
        });
      });

      axiosPatch(url, data).then(
        ({ data: responseData }) => {
          if (callback) {
            callback();
          }

          // Handle different response formats based on endpoint type
          let relationshipData;
          if (type === "assignees" && responseData.data) {
            // For assignees relationship endpoint, the response might be different
            relationshipData = responseData.data;
          } else if (
            responseData.data &&
            responseData.data.relationships &&
            responseData.data.relationships[type]
          ) {
            // Standard format for other relationships
            relationshipData = responseData.data.relationships[type].data;
          } else {
            // Fallback
            relationshipData = responseData.data || [];
          }

          console.log("Committing UPDATE_PROJECT_RELATIONSHIP with:", {
            type,
            index,
            value: relationshipData,
          });

          commit("UPDATE_PROJECT_RELATIONSHIP", {
            type,
            index,
            value: relationshipData,
          });
        },
        (err) => console.log(err)
      );
    },

    removeRelationship(
      { commit, state, dispatch },
      { projectId, id_to_delete }
    ) {
      // Find the project index from projectId
      const index = state.projects.findIndex((p) => p.id === projectId);
      if (index === -1) {
        console.error("Project not found with id:", projectId);
        return;
      }
      console.log("removeRelationship called with:", {
        projectId,
        id_to_delete,
      });
      console.log("Project at index:", state.projects[index]);
      console.log("Current assignees:", state.projects[index].assignees);

      const url = `${CREATE_PROJECT}/${state.projects[index].id}/relationships/assignees`;

      // Filter assignees - need to handle both id (userID string) and ID (numeric relationship ID)
      const assignees = state.projects[index].assignees.filter((assignee) => {
        // Check both id and ID fields for the match
        const shouldRemove =
          assignee.id === id_to_delete ||
          assignee.ID === id_to_delete ||
          assignee.id == id_to_delete || // Loose comparison for type mismatch
          assignee.ID == id_to_delete;
        return !shouldRemove;
      });

      console.log("Filtered assignees:", assignees);
      console.log("Removed assignee with id_to_delete:", id_to_delete);

      const data = {
        data: assignees.map((assignee) => {
          // IMPORTANT: Backend expects the numeric relationship ID, not the userID string
          // assignee.ID = numeric relationship ID (e.g., 732, 816, 209)
          // assignee.id = userID string (e.g., "CQ6sEWEw8yFs0ZJ9biAK")

          console.log("Mapping assignee:", assignee);

          // Always prefer the numeric ID field for the backend
          if (assignee.ID !== undefined && assignee.ID !== null) {
            console.log("Using numeric ID:", assignee.ID);
            return {
              type: "users",
              id: assignee.ID,
            };
          }

          // Fallback: If no ID field, try to use id
          // This shouldn't happen in normal flow but keeping as safety
          console.warn(
            "Assignee missing ID field, using id as fallback:",
            assignee.id
          );
          return {
            type: "users",
            id: assignee.id,
          };
        }),
      };

      console.log("Final data payload:", data);

      state.projects[index].slaves.forEach((s) => {
        dispatch("update_slaves_project_relationship", {
          type: "assignees",
          data,
          project: s,
        });
      });

      return axiosPatch(url, data).then(
        ({ data }) => {
          commit("UPDATE_PROJECT_RELATIONSHIP", {
            type: "assignees",
            index,
            value: data.data.relationships["assignees"].data,
          });
        },
        (err) => console.log(err)
      );
    },

    delete_project({ commit, state }, projectId) {
      const index = state.projects.findIndex((p) => p.id === projectId);
      if (index === -1) {
        throw new Error("Project not found");
      }
      return axiosDelete(`${CREATE_PROJECT}/${projectId}`)
        .then((res) => {
          commit("DELETE_PROJECT", index);
        })
        .catch((e) => {
          throw e;
        });
    },

    delete_projects({ commit }, ids) {
      return axiosPost(`${CREATE_PROJECT}/remove`, {
        data: {
          projectIds: ids,
        },
      })
        .then((res) => {
          commit("DELETE_PROJECTS", ids);
        })
        .catch((e) => {
          throw e;
        });
    },

    update_project({ commit, state }, data) {
      return axiosPatch(`${CREATE_PROJECT}/${data.project.id}`, data.content)
        .then((res) => {
          let _project = state.projects.find(({ id }) => id == data.project.id);
          const make = new QueryProject({
            ...res.data.data,
            index: _project.index,
          });
          const project = make.run();

          if (data.updateStatus)
            commit("UPDATE_PROJECT_STATUS", {
              index: _project.index,
              project: project,
            });
          else
            commit("UPDATE_PROJECT", {
              index: _project.index,
              project: project,
            });
        })
        .catch((e) => {
          throw e;
        });
    },

    get_task({ state }, id) {
      return axiosGet(`${CREATE_TASK}/${id}`)
        .then(({ data }) => {
          return new CommandCreateTask(data.data, {
            requestSettings: state.requestSettings,
            generalSettings: state.generalSettings,
          }).execute();
        })
        .catch((e) => {
          throw e;
        });
    },
    // archive a specific task
    update_task({ commit, state }, data) {
      return axiosGet(`${ARCHIVETASK}/${data.task.id}`)
        .then((res) => {
          state.kanban_view_data[data.task.column.index].removeTask(
            data.task.id
          );
        })
        .catch((e) => {
          throw e;
        });
    },

    //archive all task
    archives_all({ state }, data) {
      if (!data.archiveStepId) {
        throw new Error("Provide a valid step ID");
      }
      return axiosPost(`api/task/archive_task`, {
        data: { stepId: data.archiveStepId },
      })
        .then(() => {
          const stepIndex = data.index;
          // Remove all tasks from the step's task array
          state.kanban_view_data[stepIndex].clearTask((_) => _.master_id);
        })
        .catch((e) => {
          throw e;
        });
    },
    //get all archived task
    getAllArchivedTask() {
      return axiosGet(`api/task/getAllArchiveTask`)
        .then((res) => {
          return res;
        })
        .catch((e) => {
          throw e;
        });
    },

    //restore task
    restoreTasks({ state, commit }, data) {
      return axiosDelete(`api/task/restoreTask/${data.task.id}`)
        .then((res) => {
          const { tasks, ...column } = JSON.parse(
            JSON.stringify(
              state.kanban_view_data.find(({ id, ids }) =>
                state.isWhole && ids && Array.isArray(ids)
                  ? ids.includes(res.data.task.attributes.step_id)
                  : id === res.data.task.attributes.step_id
              )
            )
          );
          const make = new CommandCreateTask(
            {
              ...res.data.task,
              column,
            },
            {
              requestSettings: state.requestSettings,
              generalSettings: state.generalSettings,
            }
          );
          const task_make = make.execute();
          commit("ADD_KANBAN_COLUMN_TASK", {
            task: task_make,
            column: res.data.task.attributes.step_id,
            callback: data.callback,
          });
        })
        .catch((e) => {
          throw e;
        });
    },

    /*  archives_all({ state }, data) {
       return axiosPost(`api/task/archive_task`, data)
         .then((res) => {
           state.kanban_view_data[data.index].tasks.forEach((task) => {
             let archivers = JSON.parse(task.archivers);
             let isArchive = JSON.parse(task.archivers).ids.includes(data.userId);
             if (!isArchive) archivers.ids.push(data.userId);
 
             state.kanban_view_data[data.index].tasks
               .find(({ id }) => id === task.id)
               .updateTask("archivers", JSON.stringify(archivers));
 
             if (state.sorted) state.kanban_view_data[data.index].sortTask();
           });
 
           return "success";
         })
         .catch((e) => {
           throw e;
         });
     },
  */
    update_request_category(_, { data, id }) {
      return axiosPatch(`${BASE_TASK}/request-categories/${id}`, data);
    },
    add_request_subcategory({ state, commit }, { data, category_index }) {
      axiosPost(`${BASE_TASK}/request-subcategories`, data)
        .then((res) => {
          let toUpdate = JSON.parse(
            JSON.stringify(state.requestSettings.categories)
          );
          const { attributes, id } = res.data.data;

          toUpdate[category_index].subcategories.push({
            ...attributes,
            form: [],
            db_id: id,
            id: attributes.subcategory,
          });

          commit("UPDATE_REQUEST_CATEGORY", toUpdate);
        })

        .catch((_) => console.log(_));
    },
    delete_request_subcategory(
      { state, commit },
      { id, category_index, subcat_index }
    ) {
      return axiosDelete(`${BASE_TASK}/request-subcategories/${id}`)
        .then((res) => {
          let toUpdate = JSON.parse(
            JSON.stringify(state.requestSettings.categories)
          );
          toUpdate[category_index].subcategories.splice(subcat_index, 1);
          commit("UPDATE_REQUEST_CATEGORY", toUpdate);
          return { success: true };
        })
        .catch((error) => {
          return { success: false, message: error.response.data.message };
        });
    },
    delete_request_category({ state, commit }, { id, category_index }) {
      return axiosDelete(`${BASE_TASK}/request-categories/${id}`)
        .then((_) => {
          let toUpdate = JSON.parse(
            JSON.stringify(state.requestSettings.categories)
          );

          toUpdate.splice(category_index, 1);

          commit("UPDATE_REQUEST_CATEGORY", toUpdate);
          return { success: true };
        })
        .catch((error) => {
          return { success: false, message: error.response.data.message };
        });
    },
    load_task_general_settings({ state, commit }) {
      axiosGet(`${BASE_TASK}/settings/${state.project.id}/general`)
        .then(({ data }) => {
          commit("SET_TASK_GENERAL_SETTINGS", data);
        })
        .catch((e) => {
          console.log(e);
        });
    },
    update_request_subcategory(
      { state, commit },
      { data, id, category_index, subcat_index }
    ) {
      // Returns the promise and lets rejections propagate: the backend can now
      // refuse the update (422) when a field still used by requests is removed,
      // and callers (requestFormBuilder / requestCategories) must surface it
      // instead of showing a false "saved" toast.
      return axiosPatch(`${BASE_TASK}/request-subcategories/${id}`, data).then(
        (res) => {
          let toUpdate = JSON.parse(
            JSON.stringify(state.requestSettings.categories)
          );
          const { attributes, id } = res.data.data;
          toUpdate[category_index].subcategories[subcat_index] = {
            ...toUpdate[category_index].subcategories[subcat_index],
            ...attributes,
            form: attributes.form ? JSON.parse(attributes.form) : [],
            db_id: id,
            id: attributes.subcategory,
          };
          commit("UPDATE_REQUEST_CATEGORY", toUpdate);
          return res;
        }
      );
    },
    fetch_project_files({ commit, state }, user_id) {
      let fetchAsync = null;

      if (state.isClient) {
        fetchAsync = axiosGet(`${BASE_TASK}/files`, {
          params: {
            "filter[task_user_id]": state.user.id,
            "filter[project_id]": state.project.id,
            sp: `slucg${state.project?.attributes.locationId}tydjs`,
          },
        });
      } else if (
        (state.taskService.non_admin_permission &&
          state.user.role === "user") ||
        state.isWhole
      ) {
        let params = {};
        if (
          state.taskService.non_admin_permission &&
          state.user.role === "user"
        ) {
          params["filter[assignees]"] = user_id;
          if (!state.isWhole) params["filter[project_id]"] = state.project.id;
        }

        fetchAsync = axiosGet(`${BASE_TASK}/files`, {
          params,
        });
      } else {
        fetchAsync = axiosGet(
          `${BASE_TASK}/projects/${state.project.id}/relationships/files`
        );
      }
      fetchAsync.then(({ data: { data } }) => {
        const files = data.length
          ? data.map(({ id, attributes, relationships }, index) => {
              const { users } = relationships;
              return {
                ...attributes,
                id,
                index,
                tasks: relationships.tasks.data.map((task) => {
                  return {
                    id: task.id,
                    ...task.attributes,
                  };
                }),
                tags: relationships.tags.data.map((tag) => {
                  return {
                    id: tag.id,
                    ...tag.attributes,
                  };
                }),
                owner: {
                  id: users.data.id,
                  ...users.data.attributes,
                },
              };
            })
          : [];

        commit("SET_PROJECT_FILES", files);
      });
    },
    comment_file({ commit }, { data, file_index, callback }) {
      axiosPost(`${BASE_TASK}/file_comments`, data)
        .then((res) => {
          commit("UPDATE_PROJECT_FILE", {
            value: {
              comments_number: file.comments_number + 1,
              last_comment: {
                ...res.data.data.attributes,
                id: res.data.data.id,
                users: {
                  ...res.data.data.relationships.users.attributes,
                  id: res.data.data.relationships.users.id,
                },
              },
            },
            index: file_index,
          });
        })

        .catch((_) => console.log(_))
        .finally((_) => {
          callback();
        });
    },
    fetch_request_settings({ commit, state, dispatch }) {
      return axiosGet(
        `${BASE_TASK}/project-requests${
          state.isWhole ? "" : `?project_id=${state.project.id}`
        }`
      )
        .then(({ data }) => {
          let requestSettings = null;
          if (Object.keys(data).length) {
            const { categories, pins, ...rest } = data;
            const parsedCategoriesSettings = categories.map(
              (attributes, index) => {
                return {
                  ...attributes,
                  index,
                  subcategories: attributes.subcategories.map(
                    (sub, sub_index) => {
                      return {
                        index: sub_index,
                        ...sub,
                        id: sub.subcategory,
                        db_id: sub.id,
                        form: sub.form ?? [],
                      };
                    }
                  ),
                };
              }
            );
            const parsedPinsSettings = pins.map((attributes, index) => {
              return {
                ...attributes,
                index,
              };
            });
            requestSettings = {
              ...rest,
              categories: parsedCategoriesSettings,
              pins: parsedPinsSettings,
            };
          }
          commit("SET_REQUEST_SETTINGS", requestSettings);
          return "done";
        })
        .catch((e) => {
          console.log(e);
          dispatch("load_kanban_view", null, { root: true });
          throw e;
        });
    },
    submit_request_settings({ commit, state }, { data, callback, done }) {
      axiosPost(
        `${BASE_TASK}/project-requests/setup?filter[project_id]=${state.project.id}`,
        data
      )
        .then(({ data }) => {
          const { categories, pins, ...rest } = data;
          const parsedCategoriesSettings = categories.map(
            (attributes, index) => {
              return {
                ...attributes,
                index,
                subcategories: attributes.subcategories.map(
                  (sub, sub_index) => {
                    return {
                      index: sub_index,
                      ...sub,
                      id: sub.subcategory,
                      db_id: sub.id,
                      form: sub.form ?? [],
                    };
                  }
                ),
              };
            }
          );
          const parsedPinsSettings = pins.map((attributes, index) => {
            return {
              ...attributes,
              index,
            };
          });
          const requestSettings = {
            ...rest,
            categories: parsedCategoriesSettings,
            pins: parsedPinsSettings,
          };
          callback();
          commit("SET_REQUEST_SETTINGS", requestSettings);
        })
        .catch((e) => {
          console.log(e);
          done();
          throw e;
        });
    },
    create_request_category({ state }, data) {
      return axiosPost(
        `${BASE_TASK}/request-categories/${state.requestSettings.id}`,
        data
      );
    },

    toggle_follow(_, { id, is_follow, data }) {
      if (is_follow) {
        return axiosDelete(`${BASE_TASK}/follow/${id}`);
      } else {
        return axiosPost(`${BASE_TASK}/follow`, data);
      }
    },

    fetch_task_notes(_, taskId) {
      return axiosGet(`${TASK_NOTES}?filter[task_id]=${taskId}`)
        .then(({ data }) => {
          // Return Note instances
          if (data && data.data) {
            return data.data.map((noteData) => new Note(noteData));
          }
          return [];
        })
        .catch((error) => {
          console.error("Error fetching task notes:", error);
          return [];
        });
    },

    // Real-time subscription actions
    async subscribeToRealtime({ commit, state, dispatch }) {
      const projectId = state.project?.id;
      if (!projectId) {
        console.warn("[Realtime] No project ID available for subscription");
        return;
      }

      if (state.realtimeSubscribed) {
        console.log("[Realtime] Already subscribed to project", projectId);
        return;
      }

      try {
        await subscribeToProject(projectId, {
          onTaskCreated: (data) => {
            console.log("[Realtime] Task created:", data);
            dispatch("handleRealtimeTaskCreated", data);
          },
          onTaskUpdated: (data) => {
            console.log("[Realtime] Task updated:", data);
            dispatch("handleRealtimeTaskUpdated", data);
          },
          onTaskDeleted: (data) => {
            console.log("[Realtime] Task deleted:", data);
            dispatch("handleRealtimeTaskDeleted", data);
          },
          onTaskMoved: (data) => {
            console.log("[Realtime] Task moved:", data);
            dispatch("handleRealtimeTaskMoved", data);
          },
          onCommentAdded: (data) => {
            console.log("[Realtime] Comment added:", data);
            dispatch("handleRealtimeCommentAdded", data);
          },
        });

        commit("SET_REALTIME_SUBSCRIBED", true);
        console.log("[Realtime] Subscribed to project", projectId);
      } catch (error) {
        console.error("[Realtime] Failed to subscribe:", error);
      }
    },

    unsubscribeFromRealtime({ commit, state }) {
      const projectId = state.project?.id;
      if (projectId) {
        unsubscribeFromProject(projectId);
      }
      commit("SET_REALTIME_SUBSCRIBED", false);
      console.log("[Realtime] Unsubscribed from project", projectId);
    },

    disconnectRealtime({ commit }) {
      disconnectRealtime();
      commit("SET_REALTIME_SUBSCRIBED", false);
      console.log("[Realtime] Disconnected");
    },

    // Handle real-time task created event
    handleRealtimeTaskCreated({ commit, state }, eventData) {
      const { actor_id } = eventData?.data || {};

      // Skip if current user is the actor (they already see their own changes)
      if (actor_id && state.user?.id && actor_id === state.user.id) {
        console.log("[Realtime] Skipping task_created - current user is the actor");
        return;
      }

      const taskData = eventData?.data?.task;
      if (!taskData) return;

      // Check if task already exists to avoid duplicates
      const stepIndex = state.kanban_view_data.findIndex(
        (step) => step.id === taskData.step_id
      );

      if (stepIndex === -1) return;

      const existingTask = state.kanban_view_data[stepIndex].tasks.find(
        (t) => t.id === taskData.id
      );

      if (existingTask) {
        console.log("[Realtime] Task already exists, skipping add");
        return;
      }

      // Create task entity and add to kanban
      const { tasks, ...column } = state.kanban_view_data[stepIndex];
      const make = new CommandCreateTask(
        { ...taskData, column },
        {
          requestSettings: state.requestSettings,
          generalSettings: state.generalSettings,
        }
      );

      const task = make.execute();
      commit("ADD_KANBAN_COLUMN_TASK", {
        task,
        column: taskData.step_id,
        callback: null,
      });

      console.log("[Realtime] Task added to board:", task.id);
    },

    // Handle real-time task updated event
    handleRealtimeTaskUpdated({ commit, state }, eventData) {
      const { actor_id } = eventData?.data || {};

      // Skip if current user is the actor
      if (actor_id && state.user?.id && actor_id === state.user.id) {
        console.log("[Realtime] Skipping task_updated - current user is the actor");
        return;
      }

      const taskData = eventData?.data?.task;
      if (!taskData) return;

      // Find the task in kanban and update it
      commit("UPDATE_TASK_DEEP", taskData);
      console.log("[Realtime] Task updated in board:", taskData.id);
    },

    // Handle real-time task deleted event
    handleRealtimeTaskDeleted({ commit, state }, eventData) {
      const { task_id, step_id, actor_id } = eventData?.data || {};

      // Skip if current user is the actor
      if (actor_id && state.user?.id && actor_id === state.user.id) {
        console.log("[Realtime] Skipping task_deleted - current user is the actor");
        return;
      }

      if (!task_id || !step_id) return;

      commit("DELETE_TASK", { stepID: step_id, taskID: task_id });
      console.log("[Realtime] Task deleted from board:", task_id);
    },

    // Handle real-time task moved event
    handleRealtimeTaskMoved({ commit, state }, eventData) {
      const { task_id, from_step_id, to_step_id, task, actor_id } = eventData?.data || {};

      // Skip if current user is the actor
      if (actor_id && state.user?.id && actor_id === state.user.id) {
        console.log("[Realtime] Skipping task_moved - current user is the actor");
        return;
      }

      if (!task_id || !from_step_id || !to_step_id) return;

      const oldStepIndex = state.kanban_view_data.findIndex(
        (step) => step.id === from_step_id
      );
      const newStepIndex = state.kanban_view_data.findIndex(
        (step) => step.id === to_step_id
      );

      if (oldStepIndex === -1 || newStepIndex === -1) return;

      commit("CHANGE_KANBAN_COLUMN_TASK_COLUMN", {
        step_index: oldStepIndex,
        task_id: task_id,
        new_task: task,
        new_step_index: newStepIndex,
        new_task_index: 0,
        inListView: false,
      });

      console.log("[Realtime] Task moved:", task_id, "from", from_step_id, "to", to_step_id);
    },

    // Handle real-time comment added event - update comment count and highlight
    handleRealtimeCommentAdded({ state }, eventData) {
      const { task_id, step_id, actor_id, is_client_reply } = eventData?.data || {};

      // Skip if current user is the actor (commenter)
      if (actor_id && state.user?.id && actor_id === state.user.id) {
        console.log("[Realtime] Skipping comment_added - current user is the commenter");
        return;
      }

      if (!task_id || !step_id) return;

      // Find the step and task
      const step = state.kanban_view_data.find((s) => s.id === step_id);
      if (!step) return;

      const task = step.tasks.find((t) => t.id === task_id);
      if (!task) return;

      // Increment comment count
      if (typeof task.comments_number === "number") {
        task.comments_number++;
      } else {
        task.comments_number = 1;
      }

      // Set highlight flag for new comment indicator (uses has_notification class in boardView.vue)
      const wasUnread = !!task.has_notification;
      task.has_notification = true;

      // One more unread ticket only if this card was not already outlined -
      // a second comment on an already-unread ticket must not count twice.
      if (!wasUnread) state.unreadDelta++;

      // The card is outlined, and the "Unread" badge counts, on has_notification
      // - not on has_client_reply. So the badge has to be re-read for ANY new
      // comment. Keeping this ping inside the is_client_reply branch below left
      // teammate comments outlining a card while the badge stayed stale.
      state.clientReplyPing++; // same signal the mutation raises

      // A customer reply additionally gets the red chip (has-client-reply-chip
      // in boardView.vue) so agents can tell a waiting customer from a colleague.
      if (is_client_reply) {
        task.has_client_reply = true;
      }

      console.log("[Realtime] Comment count updated for task:", task_id, "new count:", task.comments_number);
    },

    isRealtimeConnected() {
      return isRealtimeConnected();
    },
  },
};
